import React from "react";

interface TabsProps {
  currentApp: string;
  setCurrentApp: any;
}

export const Tabs: React.FC<TabsProps> = ({ currentApp, setCurrentApp }) => {
  const TabsData = [
    {
      name: "ISN",
      value: "isn",
    },
    {
      name: "Skipper Science",
      value: "skipper_science",
    },
    {
      name: "FIsh Map",
      value: "fish_map",
    },
    {
      name: "Global Settings",
      value: "global_settings",
    },
  ];

  //handlers
  const handleLink = (linkName: string) => {
    if (currentApp === linkName) {
      return;
    }
    setCurrentApp(linkName);
  };

  return (
    <div className="flex">
      {TabsData.map((item: any, index: number) => {
        return (
          <div
            key={index}
            className={`group flex cursor-pointer justify-center items-center flex-grow-0 flex-shrink-0 px-4 py-3 ${
              currentApp === item.value
                ? "border-b-2 border-primaryMid "
                : "border-lineMid border-b-2  hover:border-lineDarkExtra"
            }`}
            onClick={() => handleLink(item.value)}
          >
            <div className="flex justify-center items-center flex-grow-0 flex-shrink-0 relative px-1.5 pt-1.5 pb-2 ">
              <p className="flex-grow-0 flex-shrink-0 text-sm font-semibold text-center uppercase text-secondary group-hover:dark:text-textMain dark:text-textMain dark:active:text-textMain">
                {item.name}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};
